export default "__VITE_ASSET__DmWeuM09__"